import { LightningElement, api } from "lwc";
import type { MarketingTileSummary } from "./types";
export type { MarketingTileSummary };

export default class MarketingTile extends LightningElement {
    @api marketingtilesummary: MarketingTileSummary = null!;

    private get getImgURL() {
        return this.marketingtilesummary.imgUrl;
    }
    
    private get getTitle() {
        return this.marketingtilesummary.title;
    }

    private get getTitleURL() {
        return this.marketingtilesummary.titleUrl;
    }

    private get getDescription() {
        return this.marketingtilesummary.description;
    }
}
